import type { Database } from "../../../../__definitions__/database-definitions";
import yup from "../../../../utils/yup";

export const slackAliasSchema = yup.object({
  name: yup.string().required("Please enter a name."),
  image: yup.string().required("Please upload an image."),
});

export type SlackAliasForm = yup.InferType<typeof slackAliasSchema>;

export type SlackAppConfig = Database["public"]["Views"]["slack_app_config"]["Row"];
